var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-alert-dialog',{attrs:{"data-test-id":"dlg-validation","title":"Please check the following fields:","visible":_vm.show,"footer":{ OK: function () { return this$1.$emit('show', false); } }},on:{"update:visible":function($event){_vm.show=$event}}},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n            "+_vm._s(Array.isArray(error) ? error[0] : error)+"\n        ")])}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f017406","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/fragments/validation.vue
// module id = xKYX
// module chunks = 0